import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Component({
  standalone: false,
  selector: "wfm-esp-tooltip-field",
  templateUrl: "./tooltip-field.component.html",
  styleUrls: ["./tooltip-field.component.scss"]
})
export class TooltipFieldComponent implements OnInit {
  private currentItem;
  private params;
  content: String;

  // a11y (ESP-18464 / Dragon): when a column opts in via `rowOpenAction` and
  // the row is openable, the cell renders the value as a real <button> so voice
  // control (Dragon) and assistive tech can target it by its visible name.
  isOpenAction = false;

  constructor(private translate: TranslateService) {

  }

  ngOnInit() {
  }

  agInit(params) {
    if (params && params.data) {
      this.currentItem = params.data;
      this.params = params;
      this.content = params.data[params.column.colDef.field];

      // a11y (ESP-18522): every cell renders as static text. The row's open
      // action is no longer a per-cell link — it is announced once at grid
      // level and activated from any cell via Enter (grid cellKeyDown), so
      // controls with different names no longer perform the same action.

      // a11y (ESP-18464 / Dragon): the openable "name" cell additionally opts
      // in to a clickable button (a single, uniquely named control per row) so
      // it is reachable by voice control without reintroducing multiple
      // same-action controls. Kept out of the tab order (tabindex=-1) so the
      // grid stays a single tab stop; keyboard users still open via Enter.
      const canOpen = typeof params.canOpen === "function" ? !!params.canOpen(params.data) : true;
      this.isOpenAction = !!params.rowOpenAction && canOpen;

      // Translation part for the field importStatus of import forecast.
      if (params.column.colDef.field === 'importStatus') {
        let translatedValue:string = this.translate.instant("imported.forecasts.importStatus." + this.content);
        if (!translatedValue.includes("imported.forecasts.importStatus.")) {
          this.content = translatedValue;
        }
      } 
      
    }
  }

  /**
   * a11y (ESP-18464 / Dragon): activates the same row-level open action as a
   * cell click/Enter. Stops propagation so the grid's cell-click handler does
   * not run a second time for the same activation.
   */
  onActivate(event: Event) {
    event.stopPropagation();
    const parent = this.params?.context?.componentParent;
    if (parent && typeof parent.performCellClick === "function") {
      parent.performCellClick({
        colDef: this.params.column.colDef,
        data: this.params.data,
        event
      });
    }
  }
}
